import React from 'react';

export const CookingPot = () => {
  const styles = {
    potContainer: {
      position: 'relative',
      width: '8rem',
      height: '6rem',
      marginBottom: '1.25rem',
      top: '-0.5rem',
    },
    pot: {
      position: 'absolute',
      bottom: 0,
      width: '8rem',
      height: '4rem',
      background: 'linear-gradient(to bottom, #4b5563, #111827)',
      borderBottomLeftRadius: '0.75rem',
      borderBottomRightRadius: '0.75rem',
      borderTopLeftRadius: '0.25rem',
      borderTopRightRadius: '0.25rem',
      boxShadow: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
      overflow: 'hidden',
    },
    liquid: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      height: '3rem',
      background: 'linear-gradient(to bottom, #fde68a, #fdba74)', // amber-200 to orange-300
      borderTopLeftRadius: '0.25rem',
      borderTopRightRadius: '0.25rem',
    },
    handleLeft: {
      position: 'absolute',
      bottom: '2rem',
      left: '-0.5rem',
      width: '1rem',
      height: '2rem',
      backgroundColor: '#4b5563', // gray-600
      borderTopLeftRadius: '9999px',
      borderBottomLeftRadius: '9999px',
    },
    handleRight: {
      position: 'absolute',
      bottom: '2rem',
      right: '-0.5rem',
      width: '1rem',
      height: '2rem',
      backgroundColor: '#4b5563', // gray-600
      borderTopRightRadius: '9999px',
      borderBottomRightRadius: '9999px',
    },
    lid: {
      position: 'absolute',
      top: 0,
      left: '1rem',
      width: '6rem',
      height: '1rem',
      backgroundColor: '#4b5563', // gray-600
      borderRadius: '9999px',
    },
    lidTop: {
      position: 'absolute',
      top: '0.5rem',
      left: '0.5rem',
      width: '7rem',
      height: '0.5rem',
      backgroundColor: '#374151', // gray-700
      borderRadius: '9999px',
    },
    steamContainer: {
      position: 'absolute',
      top: '-0.5rem',
      left: '2.5rem',
      animation: 'steam 3s ease-out infinite',
      opacity: 0,
    },
    steamContainerDelayed: {
      position: 'absolute',
      top: '-0.5rem',
      left: '3.5rem',
      animation: 'steam 3s ease-out infinite',
      animationDelay: '0.5s',
      opacity: 0,
    },
  };

  // Bubble style generator function
  const getBubbleStyle = (index) => {
    return {
      position: 'absolute',
      width: '0.75rem',
      height: '0.75rem',
      backgroundColor: '#fef3c7', // amber-100
      borderRadius: '9999px',
      opacity: '0.7',
      animation: 'bubble 2s ease-in infinite',
      left: `${10 + (index * 15)}%`,
      bottom: `${Math.random() * 70}%`,
      animationDelay: `${index * 0.3}s`,
      animationDuration: `${1 + Math.random() * 2}s`,
    };
  };

  return (
    <>
      <div style={styles.potContainer}>
        {/* Pot */}
        <div style={styles.pot}>
          {/* Liquid */}
          <div style={styles.liquid}>
            {/* Bubbles */}
            {[...Array(8)].map((_, i) => (
              <div 
                key={i}
                style={getBubbleStyle(i)}
              ></div>
            ))}
          </div>
        </div>
        
        {/* Pot handles */}
        <div style={styles.handleLeft}></div>
        <div style={styles.handleRight}></div>
        
        {/* Pot lid */}
        <div style={styles.lid}></div>
        <div style={styles.lidTop}></div>
        
        {/* Steam */}
        <div style={styles.steamContainer}>
          <svg width="40" height="40" viewBox="0 0 24 24">
            <path d="M12,2 C14,5 16,7 16,10 C16,13 14,15 12,15 C10,15 8,13 8,10 C8,7 10,5 12,2 Z" fill="white" fillOpacity="0.5" />
          </svg>
        </div>
        <div style={styles.steamContainerDelayed}>
          <svg width="40" height="40" viewBox="0 0 24 24">
            <path d="M12,2 C14,5 16,7 16,10 C16,13 14,15 12,15 C10,15 8,13 8,10 C8,7 10,5 12,2 Z" fill="white" fillOpacity="0.5" />
          </svg>
        </div>
      </div>

      {/* Animations - we need to include these to ensure animations work */}
      <style>
        {`
          @keyframes bubble {
            0% { transform: translateY(0) scale(0.8); opacity: 0.5; }
            50% { opacity: 0.8; }
            100% { transform: translateY(-40px) scale(1.2); opacity: 0; }
          }
          
          @keyframes steam {
            0% { transform: translateY(0) scale(0.8); opacity: 0; }
            30% { opacity: 0.5; }
            100% { transform: translateY(-20px) scale(1.2); opacity: 0; }
          }
        `}
      </style>
    </>
  );
};

export const CookingPreview = (insights) => {
  const hasInsights = Object.keys(insights).length > 0;
  //console.log("hasInsights",hasInsights);
  const styles = {
    cardContainer: {
      position: 'relative',
      width: '100%',
      height: '18rem', // equivalent to h-72
      borderRadius: '0.75rem', // equivalent to rounded-xl
      overflow: 'hidden',
      background: 'linear-gradient(to bottom right,rgb(33, 17, 53), #0f0225)', // from-purple-950 to-purple-900
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', // shadow-lg
    },
    glassEffect: {
      position: 'absolute',
      inset: 0,
      backdropFilter: 'blur(4px)',
      backgroundColor: 'hsl(272, 26.90%, 20.40%)',
    },
    contentContainer: {
      position: 'absolute',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '1.5rem',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    statusContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    statusDot: {
      width: '0.75rem',
      height: '0.75rem',
      borderRadius: '9999px',
      backgroundColor: '#fcd34d', // amber-300
      animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
    },
    statusText: {
      color: '#fcd34d', // amber-300
      fontSize: '0.875rem',
    },
    centralContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      margin: '1rem 0',
      height: '100%',
    },
    cookingText: {
      color: 'white',
      fontSize: '1.125rem',
      fontWeight: '500',
      marginTop: '0',
    },
    bottomGradient: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '6rem',
      background: 'linear-gradient(to top,rgb(36, 19, 56), transparent)',
    },
  };

  return (
    <div style={styles.cardContainer}>
      {/* Glass card effect */}
      <div style={styles.glassEffect}></div>
      
      {/* Card content container */}
      <div style={styles.contentContainer}>
        <div style={styles.header}>   
          {!hasInsights && ( 
            <div style={styles.statusContainer}>
              <div style={styles.statusDot}></div>
              <span style={styles.statusText}>In Development</span>
            </div>
          )}          
        </div>
        
        {/* Central cooking animation */}
        <div style={styles.centralContent}>
          {/* Use the separate CookingPot component */}
          <CookingPot />          
          <div style={styles.cookingText}>
            {hasInsights ? 'Ollie is thinking...' : 'Something is cooking...'}
          </div>
        </div>
        
      </div>
      
      {/* Bottom gradient overlay */}
      <div style={styles.bottomGradient}></div>
      
      {/* Custom animations - only keep the pulse animation here */}
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        `}
      </style>
    </div>
  );
};